<template>
    <div :style="blockstyle">
    <v-container fluid fill-height  class="py-0 px-0 contsize" v-if="load_flg==true">
    <v-layout justify-center align-center>
        <v-alert
          border="left"
          colored-border
          :type="alerttype"
          elevation="2"
          width="95%"
        >
            <v-card
                flat
            >
                <v-card-title class="pt-0">
                    {{ messagetitle }}
                </v-card-title>
                <v-card-text v-html="message" class="px-0 py-0" />
            </v-card>
        </v-alert>
    </v-layout>
    </v-container>
    </div>
</template>
<script>
export default {
    props : ["messagetype","messagetitle","message","func","blockheight",],
    computed : {
        alerttype : function(){
            if(this.messagetype == undefined || this.messagetype == "")
                return "info";
            return this.typekind[this.messagetype];
        },
    },
    data : function(){
        return {
            load_flg  : false,
            checktype : null,
            typekind : ["info","warning","error",],
            blockstyle : "",
        };
    },
    created : function(){
        this.blockstyle = "position: relative; ";
        if (this.blockheight!=undefined && this.blockheight!="")
        {
            this.blockstyle += " min-height:" + this.blockheight + ";";
        }
        else
        {
            this.blockstyle += " min-height: 200px;";
        }
        this.load_flg=true;
    },
}
</script>
<style>
.contsize{
    position: absolute;
    top: 0;
    bottom: 0;
    left : 0;
}
</style>
